(function () {
  function normalize(str) {
    return (str || '').toLowerCase().trim();
  }

  function runFilter(input) {
    var contentWrap = input.closest('.filter__content');
    if (!contentWrap) return;

    var list = contentWrap.querySelector('ul');
    if (!list) return;

    var query = normalize(input.value);
    var items = list.querySelectorAll('li');
    var queryActive = query.length > 0;

    items.forEach(function (item) {
      var label = item.getAttribute('data-filter-search-label') || '';
      var matches = !queryActive || label.indexOf(query) !== -1;
      item.classList.toggle('js-search-hidden', !matches);
    });

    list.classList.toggle('is-searching', queryActive);

    var moreBtn = contentWrap.parentElement
      ? contentWrap.parentElement.querySelector('.js-show-more')
      : null;
    if (moreBtn) {
      moreBtn.style.display = queryActive ? 'none' : '';
    }
  }

  // Capture phase (runs BEFORE the theme's own form-level input/change
  // listeners that trigger an AJAX filter refresh). Stopping propagation
  // here keeps our search box from being treated as a filter change and
  // wiped out by the resulting re-render.
  document.addEventListener(
    'input',
    function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('js-filter-search')) return;

      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      runFilter(input);
    },
    true
  );

  // Belt-and-suspenders: some themes trigger the auto-submit on 'change'
  // rather than 'input'. Stop that too for our search box specifically.
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('js-filter-search')) return;

      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    },
    true
  );
})();
